<form [formGroup]="addressFormGroup" class="mt-md-5 mt-3 offer-detail__form offer-detail__form--address">
  @if (currentProductAlreadyOrdered()) {
    <app-general-warning
      *appApplyIfNotEmpty="translationService.getTranslation('currentProduct.alreadyOrdered')"
      [warnings]="[{infoText: translationService.getTranslation('currentProduct.alreadyOrdered')}]">
    </app-general-warning>
  }

  <!--Bestehender Nutzer -->
  @if (showReadonlyCustomerAddress()) {
    <div class="mb-3 offer-detail__address-readonly"
         [innerHTML]="translationService.getTranslation('offer_address_readonly')"></div>
    <app-hup-subscription-address
      [isReadOnly]="true"
      [showAddressExt1]="isBirthdayRequired()"
      [controlGroup]="deliveryAddressGroup"
      [addressType]="translationService.getTranslation('address_delivery')"
      class="offer-detail__address-component offer-detail__address-component--readonly">
    </app-hup-subscription-address>
    <!-- Abweichende Rechnungsadresse -->
    @if (addressCombination() == AddressCombination.BOTH) {
      <div class="mt-md-5 mt-3">
        <app-hup-subscription-address
          [showActivateCheckbox]="true"
          [askForBirthday]="askForBirthday()"
          [askForEmail]="askForEmail()"
          [controlGroup]="billingAddressGroup"
          [activateCheckboxText]="'address_diffBilling'"
          [addressType]="translationService.getTranslation('address_billing')">
        </app-hup-subscription-address>
      </div>
    }
  }
  <div
    [className]="showReadonlyCustomerAddress() ? 'd-none offer-detail__address-form--hidden' : 'offer-detail__address-form'">
    @if (showWarningForOrderWithoutAddress() && clientWithoutAddressAllowed()) {
      <app-general-warning
        [warnings]="[{infoText: translationService.getTranslation('subscription.client-without-address.warning-text')}]"
        class="offer-detail__address-warning">
      </app-general-warning>
    }

    @switch (addressCombination()) {
      @case (AddressCombination.BOTH) {
        <!-- Zustelladresse -->
        <app-hup-subscription-address [showActivateCheckbox]="false"
                                      [isReadOnly]="false"
                                      [askForBirthday]="askForBirthday()"
                                      [askForEmail]="askForEmail()"
                                      [askForPhone]="askForPhone()"
                                      [isPhoneRequired]="isPhoneRequired()"
                                      [isBirthdayRequired]="isBirthdayRequired()"
                                      [controlGroup]="deliveryAddressGroup"
                                      [forProductType]="offer()"
                                      [addressType]="translationService.getTranslation('address_delivery')"
                                      class="offer-detail__address-component offer-detail__address-component--delivery">
        </app-hup-subscription-address>
        <!--Rechnungsadresse -->
        <app-hup-subscription-address [showActivateCheckbox]="true"
                                      [askForPhone]="askForPhone()"
                                      [isPhoneRequired]="isPhoneRequired()"
                                      [controlGroup]="billingAddressGroup"
                                      activateCheckboxText="address_diffBilling"
                                      [addressType]="translationService.getTranslation('address_billing')"
                                      class="offer-detail__address-component offer-detail__address-component--billing">
        </app-hup-subscription-address>
      }
      @case (AddressCombination.ONLY_BILLING) {
        <app-hup-subscription-address [showActivateCheckbox]="false"
                                      [askForBirthday]="askForBirthday()"
                                      [askForEmail]="askForEmail()"
                                      [askForPhone]="askForPhone()"
                                      [isPhoneRequired]="isPhoneRequired()"
                                      [isBirthdayRequired]="isBirthdayRequired()"
                                      [controlGroup]="billingAddressGroup"
                                      activateCheckboxText="address_diffBilling"
                                      [forProductType]="offer()"
                                      [addressType]="translationService.getTranslation('address_billing')"
                                      class="offer-detail__address-component offer-detail__address-component--billing">
        </app-hup-subscription-address>
      }
      @case (AddressCombination.ONLY_DELIVERY) {
        <app-hup-subscription-address [showActivateCheckbox]="false"
                                      [askForBirthday]="askForBirthday()"
                                      [askForEmail]="askForEmail()"
                                      [askForPhone]="askForPhone()"
                                      [isPhoneRequired]="isPhoneRequired()"
                                      [isBirthdayRequired]="isBirthdayRequired()"
                                      [controlGroup]="deliveryAddressGroup"
                                      [addressType]="translationService.getTranslation('address_delivery')"
                                      class="offer-detail__address-component offer-detail__address-component--delivery">
        </app-hup-subscription-address>
      }
    }
  </div>


  @if (hideLoginBox() && !isWinBack()) {
    <mat-form-field class="col-12 ps-2 offer-detail__form-field offer-detail__form-field--address-email">
      <mat-label [innerHTML]="translationService.getTranslation('register_email')"></mat-label>
      <input matInput formControlName="email" required
             data-cy="input-email"
             [value]="addressFormGroup.get('email').value"
             [class.is-valid]="addressFormGroup.get('email').valid">
      @if (addressFormGroup.get('email').pending) {
        <mat-spinner class="iconInInput offer-detail__input-spinner"
                     matSuffix [diameter]="18"
                     style="float: right; margin-left: 18px"></mat-spinner>
      }
      @if (addressFormGroup.get('email').valid) {
        <mat-icon class="iconInInput offer-detail__input-icon" matSuffix>
          check
        </mat-icon>
      } @else {
        <mat-error class="offer-detail__error"
        >{{
            addressFormGroup.get('email').hasError('required')
              ? translationService.getTranslation('error_email_empty')
              : translationService.getTranslation('error_email_invalid')
          }}
        </mat-error>
      }
    </mat-form-field>
  }
  <div class="text-end mt-1 offer-detail__next-btn offer-detail__next-btn--address">
    @if (!userData()) {
      <button type="button" class="me-3 offer-detail__back-btn offer-detail__back-btn--address" mat-raised-button
              (click)="parentStepper.previous()"
              [innerHTML]="translationService.getTranslation('button_back')"></button>
    }
    <button type="submit" mat-raised-button color="primary" data-cy="btn-address-next"
            (click)="parentStepper.next();onSelectAddresses();"
            [disabled]="!['VALID', 'DISABLED'].includes(addressFormGroup.get('deliveryAddress')?.status) || (isBillingAddressActive() && !addressFormGroup.get('billingAddress')?.valid)"
            [innerHTML]="translationService.getTranslation('button_next')"></button>
  </div>
</form>
